import { createSlice } from "@reduxjs/toolkit";
import { getAllCandidatesForInterviewThunk, getCandidatesForDecisionCenterThunk, getJobPositionsforDropdown, getJobPositionsThunk } from "../thunks/InterviewThunk";


const intialState = {
    totalCount: 0,
    scheduledCandidates: [],
    inProgressCandidates: [],
    completedCandidates: [],
    candidates: [],
    acceptedCandidates: [],
    rejectedCandidates: [],
    decisionCandidatesLoading: false,
    decisionCandidatesError: null,
    currentUserId: "",
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    jobroles: [],
    jobRolesForDropDown: null,
    jobsLoading: false,
    jobsError: null,
    sortConfig: { key: null, direction: null },
    scheduledCount: 0,
    inProgressCount: 0,
    completedCount: 0,
    candidateForReport: null,
    visitedSubTabs: {},
    mergedDecisionCenterCandidates: [],
}

export const InterviewManagementSlice = createSlice({
    name: "interviewManagementSlice",
    initialState: intialState,
    reducers: {
        setCandidates: (state, action) => {
            state.candidates = action.payload.candidates;
        },
        updateCandidateStatus: (state, action) => {
            const { candidate } = action.payload;
            state.completedCandidates = state.completedCandidates.filter((candi) =>
                candidate?._id !== candi._id
            )
        },
        addCandidateToShortListedList: (state, action) => {
            const data = action.payload
            console.log("data Reviced In Dispatch is ");
            console.log({ data })
            console.log({ EG: state.acceptedCandidates[0] });
            state.acceptedCandidates.push(data);
        },
        addCandidateToRejectedList: (state, action) => {
            const data = action.payload
            console.log("data Reviced In Dispatch is ");
            console.log({ data })
            console.log({ EG: state.rejectedCandidates[0] });
            state.rejectedCandidates.push(data);
        },
        addCandidateToCompletedSection: (state, action) => {
            const data = action.payload;
            state.completedCandidates.push(data);
            state.rejectedCandidates = state.rejectedCandidates.filter((candi) =>
                data?._id !== candi.candidate_id
            )
        },


        addCandidatesToScheduledSection: (state, action) => {
            const data = action.payload;
            if (!data) return;

            const candidatesArray = Array.isArray(data) ? data : [data];

            candidatesArray.forEach(candidate => {
                const mappedCandidate = {
                    interview_id: candidate._id,            // temp until backend returns real id
                    _id: candidate._id,
                    candidate_name: candidate.name,
                    candidate_email: candidate.candidate_email,
                    contact_number: candidate.contact_number || "-",
                    jdposition: candidate.job_role,
                    hr_id: candidate.hr_id,
                    combined_status: "Pending",
                    mcq_status: "NA",
                    coding_status: "NA",
                    interview_status: "NA",
                    behavioral_status: "NA",
                    typing_status: "NA",
                    invited_date: new Date().toISOString().split("T")[0],
                    scheduled_by_name: "You",
                };

                const exists = state.scheduledCandidates.some(
                    c => c.interview_id === mappedCandidate.interview_id
                );

                if (!exists) {
                    state.scheduledCandidates.push(mappedCandidate);
                }
            });

            state.totalCount = state.scheduledCandidates.length;
        },


        selectCandidateFromInterViewList: (state, action) => {
            const candidate = action.payload;
            const allLists = [
                state.scheduledCandidates,
                state.inProgressCandidates,
                state.completedCandidates,
            ];

            for (const list of allLists) {
                const index = list.findIndex(c => c._id === candidate._id);
                if (index !== -1) {
                    list[index].isSelected = !list[index].isSelected;
                    return;
                }
            }
        },

        selectAllCandidateFromInterViewList: (state, action) => {
            const { value, combined_status } = action.payload;

            if (combined_status === 'ALL') {
                // Reset all three lists
                ['scheduledCandidates', 'inProgressCandidates', 'completedCandidates'].forEach(key => {
                    state[key] = state[key].map(c => ({ ...c, isSelected: value }));
                });
                return;
            }

            const listKeyMap = {
                SCHEDULED: 'scheduledCandidates',
                PROGRESS: 'inProgressCandidates',
                COMPLETED: 'completedCandidates',
            };
            const listKey = listKeyMap[combined_status];
            if (!listKey) return;

            state[listKey] = state[listKey].map(c => ({ ...c, isSelected: value }));
        },

        toggleDecisionCenterCandidatesStatus: (state, action) => {
            const { activeSubTab, candidate } = action.payload;

            const listKey =
                activeSubTab === "ACCEPTED"
                    ? "acceptedCandidates"
                    : "rejectedCandidates";

            if (activeSubTab === "ALL") {
                state.acceptedCandidates = state.acceptedCandidates.map(c =>
                    c._id === candidate._id
                        ? { ...c, isSelected: !c.isSelected }
                        : c
                );

                state.rejectedCandidates = state.rejectedCandidates.map(c =>
                    c._id === candidate._id
                        ? { ...c, isSelected: !c.isSelected }
                        : c
                );

                state.mergedDecisionCenterCandidates = state.mergedDecisionCenterCandidates.map(c =>
                    c._id === candidate._id
                        ? { ...c, isSelected: !c.isSelected }
                        : c
                );

                return;
            }

            state[listKey] = state[listKey].map(c =>
                c._id === candidate._id
                    ? { ...c, isSelected: !c.isSelected }
                    : c
            );
        },

        toggleAllDecisionCenterCandidatesStatus: (state, action) => {
            const { activeSubTab, value } = action.payload;

            if (activeSubTab === "ALL") {
                state.acceptedCandidates = state.acceptedCandidates.map(c => ({
                    ...c,
                    isSelected: value,
                }));
                state.rejectedCandidates = state.rejectedCandidates.map(c => ({
                    ...c,
                    isSelected: value,
                }));
                state.mergedDecisionCenterCandidates = state.mergedDecisionCenterCandidates.map(c => ({
                    ...c, isSelected: value
                }));
                return;
            }

            const listKey =
                activeSubTab === "ACCEPTED"
                    ? "acceptedCandidates"
                    : "rejectedCandidates";

            state[listKey] = state[listKey].map(c => ({
                ...c,
                isSelected: value,
            }));
        },


        sortInterviewColByDir: (state, action) => {
            const dir = action.payload; // "ASC" | "DESC"

            const getScore = (c) => {
                const score = Number(c?.candidate?.score);
                return isNaN(score) ? null : score;
            };

            const sortFn = (a, b) => {
                const scoreA = getScore(a);
                const scoreB = getScore(b);

                // push null/undefined scores to bottom
                if (scoreA === null && scoreB === null) return 0;
                if (scoreA === null) return 1;
                if (scoreB === null) return -1;

                return dir === "ASC"
                    ? scoreA - scoreB
                    : scoreB - scoreA;
            };

            state.scheduledCandidates.sort(sortFn);
            state.inProgressCandidates.sort(sortFn);
            state.completedCandidates.sort(sortFn);
        },

        removeCandidateFromInterviewLists: (state, action) => {
            const candidateId = action.payload;
            // const candidateId =
            //     candidate?._id || candidate?.unique_id || candidate?.candidate_id;

            if (!candidateId) return;

            const updateFn = (c) => {
                if (
                    c?._id === candidateId ||
                    c?.unique_id === candidateId ||
                    c?.candidate_id === candidateId
                ) {
                    c.isCanceled = true;   // 👈 mark canceled
                    c.isRescheduled = false;
                }
            };

            state.scheduledCandidates.forEach(updateFn);
            state.inProgressCandidates.forEach(updateFn);
            state.completedCandidates.forEach(updateFn);
        },

        reSchedulecandidateInterview: (state, action) => {
            const candidate = action.payload;

            const candidateId =
                candidate?._id || candidate?.unique_id || candidate?.candidate_id;

            if (!candidateId) return;

            const updateFn = (c) => {
                if (
                    c?._id === candidateId ||
                    c?.unique_id === candidateId ||
                    c?.candidate_id === candidateId
                ) {
                    c.isRescheduled = true;   // 👈 mark canceled
                }
            };

            state.scheduledCandidates.forEach(updateFn);
            state.inProgressCandidates.forEach(updateFn);
            state.completedCandidates.forEach(updateFn);
        },
        sortInterviewColByDir: (state, action) => {
            const { key, direction } = action.payload; // { key: 'candidate_name', direction: 'asc' | 'desc' | null }
            state.sortConfig = { key, direction }
            if (!key || !direction) return; // reset — no sort applied

            const getValue = (candidate, key) => {
                switch (key) {
                    case 'interview_percent':
                        const score = Number(candidate?.interview_percent);
                        return isNaN(score) ? null : score;
                    case 'invited_date':
                        const date = Date.parse(candidate?.invited_date);
                        return isNaN(date) ? null : date;
                    default:
                        // handles 'candidate_name', 'candidate_email', 'contact_number', 'scheduled_by_name' etc.
                        return candidate?.[key]?.toString().toLowerCase() ?? null;
                }
            };

            const sortFn = (a, b) => {
                const valA = getValue(a, key);
                const valB = getValue(b, key);

                // Always push nulls to bottom
                if (valA === null && valB === null) return 0;
                if (valA === null) return 1;
                if (valB === null) return -1;

                if (typeof valA === 'number') {
                    return direction === 'asc' ? valA - valB : valB - valA;
                }

                // string comparison
                if (valA < valB) return direction === 'asc' ? -1 : 1;
                if (valA > valB) return direction === 'asc' ? 1 : -1;
                return 0;
            };

            state.scheduledCandidates.sort(sortFn);
            state.inProgressCandidates.sort(sortFn);
            state.completedCandidates.sort(sortFn);
        },
        sortDecisionCenterByCol: (state, action) => {
            const { key, direction } = action.payload;
            state.sortConfig = { key, direction };

            if (!key || !direction) {
                state.mergedDecisionCenterCandidates = []; // ← reset on sort clear
                return;
            }

            const getValue = (candidate, key) => {
                switch (key) {
                    case 'interview_score':
                        const score = Number(candidate?.interview_score);
                        return isNaN(score) ? null : score;
                    case 'date_of_interview':
                        const date = Date.parse(candidate?.date_of_interview);
                        return isNaN(date) ? null : date;
                    default:
                        return candidate?.[key]?.toString().toLowerCase() ?? null;
                }
            };

            const sortFn = (a, b) => {
                const valA = getValue(a, key);
                const valB = getValue(b, key);

                if (valA === null && valB === null) return 0;
                if (valA === null) return 1;
                if (valB === null) return -1;

                if (typeof valA === 'number') {
                    return direction === 'asc' ? valA - valB : valB - valA;
                }

                if (valA < valB) return direction === 'asc' ? -1 : 1;
                if (valA > valB) return direction === 'asc' ? 1 : -1;
                return 0;
            };

            state.mergedDecisionCenterCandidates = [
                ...state.acceptedCandidates,
                ...state.rejectedCandidates,
            ].sort(sortFn);

            state.acceptedCandidates = [...state.acceptedCandidates].sort(sortFn);
            state.rejectedCandidates = [...state.rejectedCandidates].sort(sortFn);
        },
        setCandidateForReport: (state, action) => {
            const candidate = action.payload;
            if (!candidate) {
                return;
            }
            state.candidateForReport = candidate
        },
        resetVisitedSubTabs: (state) => {
            state.visitedSubTabs = {};
        },
        clearInterviewManagementSlice: (state, action) => {
            const shouldClearJobRoles = action?.payload?.clearJobRoles || false;

            return {
                ...intialState,
                jobRolesForDropDown: shouldClearJobRoles ? null : state.jobRolesForDropDown,
            };
        }

    },
    extraReducers: (builder) => {
        // Thunk Cases for Getting Candidates for Interview
        //  ["SCHEDULED", "PROGRESS", "COMPLETED"]
        builder.addCase(getAllCandidatesForInterviewThunk.pending, (state, action) => {
            state.loading = true;
            state.error = null;

            state.scheduledCandidates = [];
            state.inProgressCandidates = [];
            state.completedCandidates = [];
        });
        builder.addCase(getAllCandidatesForInterviewThunk.fulfilled, (state, action) => {
            const { candidates, current_user_id, total_count, filterby } = action.payload;
            state.visitedSubTabs[filterby] = true;
            state.error = null;
            state.currentUserId = current_user_id;

            if (filterby === 'SCHEDULED') {
                state.scheduledCandidates = candidates;
                state.scheduledCount = total_count;
                state.totalCount = total_count;

                state.inProgressCandidates = [];
                state.completedCandidates = [];
            }
            if (filterby === 'PROGRESS') {
                state.inProgressCandidates = candidates;
                state.inProgressCount = total_count;
                state.totalCount = total_count;

                state.scheduledCandidates = [];
                state.completedCandidates = [];
            }
            if (filterby === 'COMPLETED') {
                state.completedCandidates = candidates;
                state.completedCount = total_count;
                state.totalCount = total_count;

                state.scheduledCandidates = [];
                state.inProgressCandidates = [];
            }
            if (filterby === 'ALL') {
                const scheduled = candidates.filter(c => c.combined_status === 'Pending');
                const inProgress = candidates.filter(c => c.combined_status === 'In Progress');
                const completed = candidates.filter(c => c.combined_status === 'Completed');

                state.scheduledCandidates = scheduled;
                state.inProgressCandidates = inProgress;
                state.completedCandidates = completed;

                // Use actual array lengths since ALL fetches everything at once
                state.scheduledCount = scheduled.length;
                state.inProgressCount = inProgress.length;
                state.completedCount = completed.length;

                state.totalCount = total_count;
            }
            state.loading = false;
        });
        builder.addCase(getAllCandidatesForInterviewThunk.rejected, (state, action) => {
            // if (action.meta.aborted) {
            //     console.log("Thunk aborted dynamically, ignoring state rejection.");
            //     return;
            // }
            // state.loading = false;
            state.error = action.payload;
            console.error("Failed to fetch candidates for interview:", action.payload);
        });

        // Thunk Cases for Getting Job Positions In Filter for Interview Management
        builder.addCase(getJobPositionsThunk.pending, (state, action) => {
            state.jobsLoading = true;
            state.jobsError = null;
        });

        builder.addCase(getJobPositionsThunk.fulfilled, (state, action) => {
            console.log({ PAYLOAD: action.payload })
            state.jobroles = action.payload;
            state.jobsLoading = false;
            state.jobsError = null;
        });
        builder.addCase(getJobPositionsThunk.rejected, (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.payload;
            console.error("Failed to fetch job positions:", action.payload);
        });

        // get Jd Positions for View Jd Model 
        builder.addCase(getJobPositionsforDropdown.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getJobPositionsforDropdown.fulfilled, (state, action) => {
            const rolesArray = Object.entries(action.payload)
                .filter(([id, job]) =>
                    job.status === "finalized" || job.status === null)
                .map(([id, job]) => ({
                    id,
                    role: job.job_role,
                }));
            state.jobRolesForDropDown = rolesArray;
            state.loading = false;
            state.error = null;
        });

        builder.addCase(getJobPositionsforDropdown.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
        });

        // Decision Center Thunk 
        builder.addCase(getCandidatesForDecisionCenterThunk.pending, (state, action) => {
            state.decisionCandidatesLoading = true;
            state.decisionCandidatesError = null;
        });
        builder.addCase(getCandidatesForDecisionCenterThunk.fulfilled, (state, action) => {
            const { data, status } = action.payload;
            if (status === "SELECTED") {
                state.acceptedCandidates = data;
            }
            if (status === "REJECTED") {
                state.rejectedCandidates = data;
            }
            state.decisionCandidatesLoading = false
        });
        builder.addCase(getCandidatesForDecisionCenterThunk.rejected, (state, action) => {
            const data = action.payload
            state.decisionCandidatesLoading = false;
            state.decisionCandidatesError = data;
        })
    }
})


export const { setCandidates, updateCandidateStatus, addCandidateToShortListedList, addCandidateToRejectedList, addCandidateToCompletedSection, addCandidatesToScheduledSection, selectCandidateFromInterViewList, clearInterviewManagementSlice, sortInterviewColByDir, removeCandidateFromInterviewLists, selectAllCandidateFromInterViewList, toggleDecisionCenterCandidatesStatus, toggleAllDecisionCenterCandidatesStatus, reSchedulecandidateInterview, sortDecisionCenterByCol, setCandidateForReport, resetVisitedSubTabs } = InterviewManagementSlice.actions;